

/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Spin, InputNumber, Space, DatePicker, Popover } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './cohortModule.css';
import { ContextHandler } from '../../public/js/contextHandler';
import CohortModuleModal from './cohortModuleModal';
import AssignmentModal from './assignmentModal';
import CohortProgModal from './cohortProgModal'
import CohortProgSearchModal from './cohortProgSearchModal'
import context from '../../public/js/context';

const { TabPane } = Tabs;
const CohortModule = (props) => {
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [isDeleteFrame2, setIsDeleteFrame2] = useState(false);

    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [cohortProg, setCohortProg] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [cohortList, setCohortList] = useState([]);
    const [deptList, setDeptList] = useState([]);
    const tableColumns = {
        cohortYear: "cohortYear",
        cohortProgId: "cohortProgId",
    }
    const [isAssignmentModal, setIsAssignmentModal] = useState(false);
    const [assignmentTable, setAssignmentTable] = useState([]);
    const [isProgModal, setIsProgModal] = useState(false);
    const [cohortModel, setCohortModel] = useState({});
    const [deleteAssign, setDeleteAssign] = useState({});
    const [updateInd, setUpdateInd] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});

    useEffect(() => {
        searchCohortList()
        searchAllDept();
    }, []);

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortModule/moduleSearchAll").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortModule/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
                let newModel = { cohortId: Config?.cohort?.cohortId };
                setSearchModel(newModel);
                form2.setFieldsValue(newModel)
                search(pageSize, 1, "N", false, newModel)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("cohortModule/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const reset = () => {
        messageShowHandler();
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        let newModel = { cohortId: cohortList[0]?.cohortId };
        setSearchModel(newModel);
        setOldSearchModel(newModel);
        form2.setFieldsValue(newModel)
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({status: 'INCOMPLETE'});
        setFlag("add");
        setAssignmentTable([])
        setCohortModel({})
        setTabIndex("2");
        setCohortProg({})
    }
    const download = () => {
        setIsCohortProgModal(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        searchById(model.cohortModuleId)
        setTabIndex("2");
        setFlag("edit");
    }

    const updateAssign = (model, e) => {
        messageShowHandler();//清空提示信息
        setCohortModel({ ...model, ...{ flag: "edit", cohortModuleId: cohortProg.cohortModuleId } })
        setIsAssignmentModal(true)
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? '',
            moduleCode: model.moduleCode ?? "",
            moduleName: model.moduleName ?? "",
            curriculumHours: model.curriculumHours ?? "",
            otherLearningTrainingHours: model.otherLearningTrainingHours ?? "",
            progTitle: model.progTitle ?? "",
            progCode: model.progCode ?? "",
            status: model.status ?? "",
            markDisplayDate: model.markDisplayDate ? moment(new Date(model.markDisplayDate), Config.dateFormat5) : "",
            wpaDisplayDate: model.wpaDisplayDate ? moment(new Date(model.wpaDisplayDate), Config.dateFormat5) : "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteFrameClose2 = (state) => {
        if (state) {
            setIsLoad(true);
            setSpinInfo(trans.deleteData[Config.backLang]);
            let deleteModel = deleteAssign;
            deleteModel.menuFuncId = Config.funcInfo.funcId;
            Base.callBackApi("cohortModule/deleteAssign", deleteModel).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(cohortProg.cohortModuleId)
                    errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
        setIsDeleteFrame2(false);
    }


    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = cohortProg;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("cohortModule/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        let model = {
            cohortModuleId: cohortProg.cohortModuleId,
            moduleId: cohortProg.moduleId,
            menuFuncId: Config.funcInfo.funcId,
            cohortId: values.cohortId,
            curriculumHours: values.curriculumHours,
            moduleCode: values.moduleCode,
            moduleName: values.moduleName,
            status: values.status,
            otherLearningTrainingHours: values.otherLearningTrainingHours,
            cohortProgId: cohortModel.cohortProgId
        }
        if (Base.isNotEmpty(values.markDisplayDate)) {
            model.markDisplayDate = values.markDisplayDate
        }
        if (Base.isNotEmpty(values.wpaDisplayDate)) {
            model.wpaDisplayDate = values.wpaDisplayDate
        }
        setIsLoad(true)
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "cohortModule/insert";
        } else if (flag === 'edit') {
            url = "cohortModule/update"
            model.lastUpdatedDate = cohortProg.lastUpdatedDate;
        }
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                setFlag("edit");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (cohortModuleId) => {
        setIsLoad(true);
        Base.callBackApi("cohortModule/searchById", cohortModuleId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let cohortModule = data.object;
                initForm(cohortModule);
                setCohortProg(cohortModule)
                setCohortModel({ ...cohortModel, ...cohortModule })
                setAssignmentTable(cohortModule.cohortModuleAssignModelList)
                setUpdateInd(!(cohortModule.cohortModuleAssignModelList && cohortModule.cohortModuleAssignModelList.length > 0))
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setCohortProg(model)
        setIsDeleteFrame(true);
        if (type == "segment") {
            setDeleteTipText("Module Code" + ":" + model.moduleCode + "")
        }
    }

    const deleteOneAssign = (model, e) => {
        e.stopPropagation();
        setDeleteAssign(model)
        setIsDeleteFrame2(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag, model) => {
        if (flag) {
            setCohortProg({
                ...cohortProg,
                moduleCode: model.moduleCode,
                moduleName: model.moduleName,
                moduleId: model.moduleId
            })
            form.setFieldsValue({
                moduleCode: model.moduleCode ?? "",
                moduleName: model.moduleName ?? '',
            });
        }
        setIsCohortProgModal(false);
    }

    
    const searchModuleClose = (flag, model1) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ moduleCode: model1.moduleCode, moduleName: model1.moduleName, } };
            });
        }
        setIsSearchModuleModal(false);
    }
    


    const assignmentClose = (flag, model) => {
        searchById(cohortModel.cohortModuleId)
        if (flag) {
            errFrameShow("success", trans.saveSuccess[Config.backLang]);
        }
        setIsAssignmentModal(false);
    }

    const cohortProgClose = (flag, model) => {
        if (flag) {
            form.setFieldsValue({
                progCode: model.progCode ?? "",
                progTitle: model.progTitle ?? '',
            });
            setCohortModel({ ...cohortModel, ...model })
        }
        setIsProgModal(false);
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    const validateRange = (value) => {
        if (parseFloat(value) > 9999.99 || parseFloat(value) < 0) {
            return Promise.reject('Value error, Range should be between 0 and 9999.99 .');
        }
        return Promise.resolve();
    };

    const selectProgramme = () => {
        setIsProgModal(true)
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setCohortProgModel(cohortProg);
        }
        setIsSearchCohortProgModal(false);

    }

    const cohortChange = (cohortId) => {
        setCohortModel({ ...cohortModel, ...{ cohortId: cohortId } })
        form.setFieldsValue({
            progCode: "",
            progTitle: '',
        });
    }

    const numFormatter = (value, label) => {
        let parts = value.toString().split('.');
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].slice(0, 2);
        }
        form.setFieldsValue({
            [label]: parts.join('.'),
        })
        form.validateFields([label])
        return parts.join('.');
    };

    /*eslint-disable*/
    const columns = [
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth7',
            // sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: 'Module Code',
            dataIndex: 'moduleCode',
            className: 'tableWidth15',
        },
        {
            title: 'Module Name',
            dataIndex: 'moduleName',
            className: 'tableWidth20',
        },
        {
            title: 'Programme Code',
            dataIndex: 'progCode',
            className: 'tableWidth15',
        },
        {
            title: 'Programme Name',
            dataIndex: 'progTitle',
            className: 'tableWidth20',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: 'tableWidth10',
            render: text => ContextHandler.getMapValue('cohortModuleStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                {/* <div className='sysUpdate' onClick={(e) => view(record, e)} hidden={Config.funcInfo.canUpdate === "Y"}><EyeOutlined /> {trans.view[Config.backLang]}</div> */}
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "segment")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    const assignmentColumns = [
        {
            title: 'Assignment',
            dataIndex: 'assignSeq',
            className: 'tableWidth10',
        },
        {
            title: 'Assignment Name',
            dataIndex: 'assignName',
            className: 'tableWidth30',
        },
        {
            title: 'Assignment Deadline',
            dataIndex: 'assignDeadline',
            className: 'tableWidth22',
            render: (text) => <div>
                <div>{text ? moment(text).format(Config.dateFormat5) : ""}</div>
            </div>
        },
        {
            title: 'Status',
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('assignStatusMap', text)
        },
        {
            title: 'Weighting',
            dataIndex: 'assignWeight',
            className: 'tableWidth10',
        },
        {
            title: 'Use Turnitin',
            dataIndex: 'turnitinReqInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 150,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => updateAssign(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    return (
        <div id="container" className="template cohortModule">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 删除弹框 */}
                    {isDeleteFrame2 ? <PopupFrame close={deleteFrameClose2} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} onFinish={onSearch}>
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle mustFill">{trans.cohortYear[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Form.Item
                                                    name="cohortId"
                                                    rules={[
                                                        { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                        value={searchModel.cohortId || ''}
                                                        onChange={(e) => searchChange('cohortId', e)}
                                                    >
                                                        <Option value=''></Option>
                                                        {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.deptCode[Config.backLang]}</div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.moduleCode || ''} disabled
                                                  placeholder={trans.deptCode[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                                            {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">Programme </div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.progCode || ''} disabled
                                                    placeholder="Programme "
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                                            {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1100 }}
                                    rowKey="cohortModuleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={"Module Parameters by Cohort"} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Module Code</div>
                                        <div className="sysInput btnInput">
                                            <Form.Item
                                                name="moduleCode"
                                                rules={[
                                                    { required: true, message: trans.programmeCodeNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Module Code' maxLength={60} disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        <Button type="primary" className='sysBtn btnBlue' onClick={download}>Select</Button>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Module Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleName"
                                            >
                                                <Input type="text" placeholder='Module Name' maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortId"
                                                rules={[
                                                    { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]} disabled={flag !== 'add'} onChange={(cohortId) => cohortChange(cohortId)}>
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    {
                                        (flag === "add") ?
                                            <div className='sysCol'>
                                                <div className="sysParam mustFill">Programme Code</div>
                                                <div className="sysInput btnInput">
                                                    <Form.Item
                                                        name="progCode"
                                                        rules={[
                                                            { required: true, message: "Programme Code is required." }
                                                        ]}
                                                    >
                                                        <Input type="text" placeholder='Programme Code' maxLength={60} disabled className='BUttonProgramme' />
                                                    </Form.Item>
                                                </div>
                                                <Button type="primary" className='sysBtn btnBlue' onClick={selectProgramme} >Select</Button>
                                            </div>
                                            :
                                            <div className='sysCol'>
                                                <div className="sysParam mustFill">Programme Code</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="progCode"
                                                        rules={[
                                                            { required: true, message: "Programme Code is required." }
                                                        ]}
                                                    >
                                                        <Input type="text" placeholder='Programme Code' maxLength={60} disabled className='BUttonProgramme' />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                    }

                                    <div className='sysCol'>
                                        <div className="sysParam">Programme Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                            >
                                                <Input type="text" placeholder='Programme Name' maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Total Curriculum Hours</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="curriculumHours"
                                                rules={[
                                                    {
                                                        required: false,
                                                        validator: (rule, value) => validateRange(value)
                                                    },
                                                ]}
                                            >
                                                <InputNumber placeholder="Total Curriculum Hours" className='InputNumberInput'
                                                    formatter={(value) =>
                                                        numFormatter(value, "curriculumHours")
                                                    }
                                                    maxLength={7}
                                                    onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Other Learning Activities Hours</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="otherLearningTrainingHours"
                                                rules={[
                                                    {
                                                        required: false,
                                                        validator: (rule, value) => validateRange(value)
                                                    },
                                                ]}
                                            >
                                                <InputNumber placeholder="Other Learning Activities Hours" className='InputNumberInput'
                                                    formatter={(value) =>
                                                        numFormatter(value, "otherLearningTrainingHours")
                                                    }
                                                    maxLength={7}
                                                    onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput flexTitle">Mark Display Date
                                            <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                                {`You can specify when you would like the students to be able to view their marks (including Assignments, Total WPA, and Total Module marks).`}
                                            </div>} trigger="hover">
                                                <div className='labelCircle'><InfoCircleOutlined /></div>
                                            </Popover> 
                                        </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="markDisplayDate"
                                            >
                                                <DatePicker placeholder="Mark Display Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    allowClear={true}

                                                    format={Config.dateFormat5} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput flexTitle">WPA Display Date
                                        <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                            {`Please specify when you would like the students to be able to view their completed WPA form (specifically when its status is set to "Accepted").`}
                                        </div>} trigger="hover">
                                            <div className='labelCircle'><InfoCircleOutlined /></div>
                                        </Popover>  
                                        </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="wpaDisplayDate"
                                            >
                                                <DatePicker placeholder="WPA Display Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    allowClear={true}

                                                    format={Config.dateFormat5} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Status</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="status"
                                            >
                                                <Select className="sysSelect" placeholder='Status' disabled >
                                                    <Option value=''></Option>
                                                    {context.cohortModuleStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                            <div className="sysBodyRow">
                                <div className="userRoleTitleRow">Assignment</div>
                            </div>
                            <div className="packing-table " id="tableOne">
                                <Table
                                    scroll={{ x: 1200 }}
                                    rowKey="cohortModuleAssignId" //Key值
                                    columns={assignmentColumns} //列名
                                    dataSource={assignmentTable} //数据
                                    pagination={false}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isCohortProgModal && <CohortModuleModal onClose={uploadClose} />}
            {isSearchModuleModal && <CohortModuleModal onClose={searchModuleClose} />}
            {isAssignmentModal && <AssignmentModal onClose={assignmentClose} cohortModel={cohortModel} />}
            {isProgModal && <CohortProgModal onClose={cohortProgClose} cohortModel={cohortModel} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} progModel={cohortProgModel} />}

        </div>
    )

}

export default CohortModule;